<template>
  <!-- 渠道提成流程详情 -->
  <div class="bid-follow-process-detail">
    <div class="title">渠道邀请码审批进度</div>
    <div>
      <sub-title title="渠道用户"></sub-title>
      <div class="details-table">
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">负责人：</div>
            <div class="item-right">{{ details.DockingPeople }}</div>
          </div>
          <div class="details-box-item">
            <div class="item-left">账号：</div>
            <div class="item-right">
              {{ details.LoginName }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">角色类型：</div>
            <div class="item-right">
              {{ details.RoleStr }}
            </div>
          </div>
        </div>
      </div>
      <div class="channel-wrap" v-for="(item, index) in details.ChannelInfos" :key="index">
        <sub-title :title="`渠道 ${index + 1}`" />
        <div class="details-table">
          <div class="details-box-item">
            <div class="item-left">邀请码：</div>
            <div class="item-right">{{ item.Code }}</div>
          </div>
          <div class="details-box-item">
            <div class="item-left">所属平台：</div>
            <div class="item-right">
              {{ item.SourceType | sourceTypeFiler }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">渠道类型：</div>
            <div class="item-right">
              {{ item.ChannelType | commissionTypeFiler }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">渠道提成方式：</div>
            <div class="item-right">
              {{ item.CommissionType == 'SubstractCharge' ? '(保函费 - 手续费) * 提成比例' : '保函费 * 提成比例' }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">渠道提成比例：</div>
            <div class="item-right">
              {{ (item.Rate * 100).toFixed(2) + '%' }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">手续费类型：</div>
            <div class="item-right">
              {{ item.ChargeType == 'Actual' ? '实际手续费' : '手续费' }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">客户提成方式：</div>
            <div class="item-right">
              {{ item.CustomerCommissionType == 'SubstractCharge' ? '(保函费 - 手续费) * 提成比例' : '保函费 * 提成比例' }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">客户提成比例：</div>
            <div class="item-right">
              {{ (item.CustomerRate * 100).toFixed(2) + '%' }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">结算时间：</div>
            <div class="item-right">
              {{ item.DateType == 'OpenBidTime' ? '开标时间' : '出函时间' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 流程图 -->
    <flow-chart :details="processData" :selTab="type" :TemplateID="TemplateID" @close="$emit('refresh')" v-if="JSON.stringify(details) != '{}'" />
  </div>
</template>
<script>
import { WorkflowQuery, roleQuery } from '@/http/api';
let that = null;
export default {
  props: {
    ID: {
      // 当前id
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
    TemplateID: {
      // 流程ID
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      processData: {},
      details: {},
      roleArr: [],
    };
  },
  created() {
    that = this;
  },
  filters: {
    sourceTypeFiler(val) {
      let temp = that.$sourceType.find((v) => v.Name == val);
      return (temp && temp.Title) || '--';
    },
    commissionTypeFiler(val) {
      let temp = that.$orderTeamTypes.find((v) => v.Name == val);
      return (temp && temp.Title) || '--';
    },
  },
  watch: {
    ID: {
      handler(val, oldVal) {
        this.getRoleQuery();
      },
      immediate: true,
    },
  },
  methods: {
    // 获取角色
    getRoleQuery() {
      roleQuery().then((res) => {
        this.roleArr = res;
        this.getDetails();
      });
    },
    getDetails() {
      this.$emit('loading', true);
      WorkflowQuery({ workflowId: this.ID, templateId: this.TemplateID }, 'Get').then((res) => {
        if (!!res && JSON.stringify(res) != '{}') {
          let temp = this.roleArr.find((v) => v.Name == res.ChannelUserInfo.Roles);
          res.ChannelUserInfo.RoleStr = (temp && temp.NameCn) || '--';
          this.details = res.ChannelUserInfo;
          this.processData = res;
        }
        this.$emit('loading', false);
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import './details.less';
.channel-wrap {
  .details-table {
    display: flex;
    flex-wrap: wrap;
    .details-box-item {
      width: 33.33333%;
      .item-left {
        width: 120px;
        min-width: 120px;
        text-align: right;
      }
    }
  }
}
</style>
